"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLoading = void 0;
var react_1 = __importDefault(require("react"));
var ErrorLoading_module_scss_1 = __importDefault(require("./ErrorLoading.module.scss"));
var ErrorLoading = function () {
    return react_1.default.createElement("h3", { className: ErrorLoading_module_scss_1.default.error_message }, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
};
exports.ErrorLoading = ErrorLoading;
